import React from 'react';
import styles from './ComoFunciona.module.css';

import paso1Img from '../../assets/images/img_paso1.png';
import paso2Img from '../../assets/images/img_paso2.png';
import paso3Img from '../../assets/images/img_paso3.png';
import paso4Img from '../../assets/images/img_paso4.png';


const ComoFunciona = () => {
  return (
    <section>
      <h2 className={styles.titulo}>
        ¿Cómo funciona <span className={styles.plinkP}>P</span>link?
      </h2>
      <div className={styles.comoFunciona}>
        {/* Paso 1 */}
        <div className={styles.comoFuncionaChild}>
          <img src={paso1Img} alt="Paso 1" className={styles.gridImage} />
          <div className={styles.textOverlay}>
            <div className={styles.overlay}>
              <span className={styles.numero}>1</span>
              <div>
                <h3>Generar un enlace de cobro</h3>
                <p>Configura el monto, concepto y método de cobro.</p>
              </div>
            </div>
          </div>
        </div>

        {/* Paso 2 */}
        <div className={styles.comoFuncionaItem}>
          <img src={paso2Img} alt="Paso 2" className={styles.gridImage} />
          <div className={styles.textOverlay}>
            <div className={styles.overlay}>
              <span className={styles.numero}>2</span>
              <div>
                <h3>Comparte el link</h3>
                <p>Envíalo por WhatsApp, Email, (individual o masivo), cobra a un solo cliente o envía múltiples enlaces simultáneamente.</p>
              </div>
            </div>
          </div>
        </div>

        {/* Paso 3 */}
        <div className={styles.comoFuncionaInner}>
          <img src={paso3Img} alt="Paso 3" className={styles.gridImage} />
          <div className={styles.textOverlay}>
            <div className={styles.overlay}>
              <span className={styles.numero}>3</span>
              <div>
                <h3>Cobros al instante</h3>
                <p className={styles.parrafo3}>Cobra en segundos, y obtén los fondos de manera segura.</p>
              </div>
            </div>
          </div>
        </div>

        {/* Paso 4 */}
        <div className={styles.rectangleDiv}>
          <img src={paso4Img} alt="Paso 4" className={styles.gridImage} />
          <div className={styles.textOverlay}>
            <div className={styles.overlay}>
              <span className={styles.numero}>4</span>
              <div>
                <h3>Consolida</h3>
                <p>Consolida tus transacciones individuales masivas y genera tus reportes.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ComoFunciona;